import { homepage as HOME_URL } from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useWhoamiQuery } from "../../api/userApi";
import { useEffect } from "react";
import { setCredentials } from "../../store/global/authSlice";
import Loading from "../../components/feedback/Loading";

function AutoLogin({ children }) {
    const { isAuthenticated } = useSelector((state) => state.auth);
    const location = useLocation();
    const from = location.state?.from;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const me = useWhoamiQuery();
    const handleRedirectToHomePage = () => navigate(from ?? HOME_URL, { replace: true });

    useEffect(() => {
        const user = me.data?.user;
        if (!me.isFetching && me.isSuccess && user) {
            dispatch(setCredentials({ user }));
        }
    }, [me.isFetching, me.isSuccess, me.data, dispatch, setCredentials]);

    useEffect(() => {
        if (!me.isLoading && isAuthenticated) {
            handleRedirectToHomePage();
        }
    }, [me.isLoading, isAuthenticated, handleRedirectToHomePage]);

    return me.isLoading ? <Loading /> : children;
}

export default AutoLogin;
